import { LOCALES } from "@/utils/localeUtils.js";

const messageModules = import.meta.glob("./locales/*.json", { eager: true });

export function buildLocaleMessages() {
  const messages = {};
  for (const locale of LOCALES) {
    const mod = messageModules[`./locales/${locale.code}.json`];
    if (!mod) continue;
    // Vite 4 returns the JSON object directly; Vite 5 wraps it with .default
    const translations = mod.default ?? mod;
    if (translations && typeof translations === "object") {
      messages[locale.code] = translations;
    }
  }
  return messages;
}

export const localeMessages = buildLocaleMessages();

export function translateForLocale(locale, key, fallbackLocale) {
  const parts = key.split(".");
  let val = localeMessages[locale] ?? localeMessages[fallbackLocale];
  for (const part of parts) {
    val = val?.[part];
    if (val === undefined) return key;
  }
  return val ?? key;
}
